<template>
    <article class="cart-popup__item">
        <div class="row">
            <div class="col-md-6">
                <div class="row">
                    <div class="col-2 cart-popup__delete-item-column d-flex align-items-center " style="z-index: 99">
                        <button @click="onDeleteClick()" class="cart-popup__delete-item">
                            <i class="fa fa-trash fa-trash-circle"></i>
                        </button>
                    </div>
                    <div class="layer_cart_img col">
                        <img
                            class="layer_cart_img img-fluid"
                            :src="product.image"
                            :alt="product.name"
                            :title="product.name"
                        />
                    </div>
                </div>
            </div>
            <div class="col-md-6  cart-popup__product-details pl-0">
                <div class="row">
                    <div class="col-12 mb-3">
                        <div>
                            <span v-text="product.quantity" id="layer_cart_product_quantity"></span> x
                            <span id="layer_cart_product_title">{{ truncatedName }}</span>
                        </div>
                    </div>
                    <div class="col-12 d-flex align-items-center justify-content-between">
                        <div class="cart-popup__total-label">
                            {{ $t("blockCart.cartTotal") }}:
                        </div>
                        <div class="cart-popup__price">
                            <span v-text="product.price" id="layer_cart_product_price"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </article>
</template>

<script>
export default {
    name: 'BlockCartItem',
    props: {
        product: {
            required: true,
            type: Object
        }
    },
    methods: {
        onDeleteClick() {
            ajaxCart.remove(this.product.id, this.product.idCombination, null, this.product.idAddressDelivery);
        },
        truncate: function(value, size){
            value = value.toString();

            if (value.length <= size) {
                return value;
            }
            return value.substr(0, size) + '...';
        }
    },
    computed: {
        truncatedName() {
            return this.truncate(this.product.name, 32);
        }
    }
}
</script>
